(() => {
  "use strict";

  window.BYL = window.BYL || {};

  const services = BYL.services;
  const customer = BYL.customer;
  const engine = BYL.engine;

  if (!services || !customer || !engine) {
    throw new Error(
      "BYL UI requires byl-services.js, byl-customer.js and byl-order-engine.js."
    );
  }

  /* =========================================================
     CALLBACKS PROVIDED BY byl-core.js
     ========================================================= */

  const callbacks = {
    onSchoolCode: null,
    onSchoolChange: null,
    onAddSchool: null,
    onSchoolDelete: null,
    onSchoolFavorite: null,

onProfileSelect: null,
onProfileEdit: null,
onProfileDelete: null,
onProfileSave: null,
onProfileCancel: null,
onProfileHistoryDecision: null,

onCalendarOpen: null,
onCalendarClose: null,
onCalendarClear: null,
onCalendarSubmit: null,
onCalendarChange: null,

    onBrandSelect: null,

    onMainSelect: null,
    onAddOnToggle: null,
    onToppingToggle: null,
    onOptionChange: null,
    onCustomInputChange: null,

    onPeriodChange: null,
    onPeriodChoice: null,

    onOrderAnyway: null,
    onCopyDateForward: null,
    onAddToCart: null
  };


  function configure(next = {}) {
    for (const key of Object.keys(callbacks)) {
      if (typeof next[key] === "function") {
        callbacks[key] = next[key];
      }
    }
  }


  /* =========================================================
     DOM
     Exact IDs from current Liquid file.
     ========================================================= */

  const $ = id =>
    document.getElementById(id);


  function dom() {
    return {
      app: $("byl-app"),

      headerSubtitle:
        $("byl-header-subtitle"),

      message:
        $("byl-message"),


      /* School gate */

      gate:
        $("byl-school-gate"),

      codeForm:
        $("byl-school-code-form"),

      codeInput:
        $("byl-school-code"),

      codeSubmit:
        $("byl-school-code-submit"),

      codeError:
        $("byl-school-code-error"),


      /* Main ordering app */

      ordering:
        $("byl-ordering"),

      currentSchool:
        $("byl-current-school"),

      schoolSwitcher:
        $("byl-school-switcher"),

      addSchool:
        $("byl-add-school"),


      /* Profiles */

      profileSection:
        $("byl-profile-section"),

      profileList:
        $("byl-profile-list"),

      newProfile:
        $("byl-new-profile"),

      profileEditor:
        $("byl-profile-editor"),

      memberType:
        $("byl-member-type"),

      firstName:
        $("byl-first-name"),

      lastName:
        $("byl-last-name"),

      classroomField:
        $("byl-classroom-field"),

      classroom:
        $("byl-classroom"),

      profileNotes:
        $("byl-profile-notes"),

      profileUse:
        $("byl-profile-use"),

      profileCancel:
        $("byl-profile-cancel"),


      /* Brands */

      brandSection:
        $("byl-brand-section"),

      brandDescription:
        $("byl-brand-description"),

      brandList:
        $("byl-brand-list"),


      /* Order */

      orderSection:
        $("byl-order-section"),

      backToBrands:
        $("byl-back-to-brands"),

      orderBrandName:
        $("byl-order-brand-name"),

      orderBrandMeta:
        $("byl-order-brand-meta"),

      existingSummary:
        $("byl-order-existing-summary"),

      workspace:
        $("byl-order-workspace"),

      orderOptions:
        $("byl-order-options"),

      orderSummary:
        $("byl-order-summary"),

      orderTotal:
        $("byl-order-total"),

      addToCart:
        $("byl-add-to-cart"),


      /* Add school modal */

      schoolModal:
        $("byl-school-modal"),

      addSchoolForm:
        $("byl-add-school-form"),

      addSchoolCode:
        $("byl-add-school-code"),

      addSchoolError:
        $("byl-add-school-error"),


      /* Calendar ordering */

      calendarSection:
        $("byl-calendar-order"),

      calendarButton:
        $("byl-calendar-button"),

      calendarClose:
        $("byl-calendar-close"),

      calendarProfileSummary:
        $("byl-calendar-profile-summary"),

      calendarGrid:
        $("byl-calendar-grid"),

      calendarCount:
        $("byl-calendar-count"),

      calendarTotal:
        $("byl-calendar-total"),

      calendarClear:
        $("byl-calendar-clear"),

      calendarSubmit:
        $("byl-calendar-submit"),


      /* Loading */

      loading:
        $("byl-loading"),

      loadingText:
        $("byl-loading-text")
    };
  }


  /* =========================================================
     HELPERS
     ========================================================= */

  function clean(value) {
    return String(
      value ?? ""
    ).trim();
  }


  function clear(element) {
    if (element) {
      element.replaceChildren();
    }
  }


  function create(
    tag,
    className = "",
    text = null
  ) {
    const element =
      document.createElement(tag);

    if (className) {
      element.className =
        className;
    }

    if (
      text !== null &&
      text !== undefined
    ) {
      element.textContent =
        String(text);
    }

    return element;
  }


  function makeButton(
    text,
    className
  ) {
    const button =
      create(
        "button",
        className,
        text
      );

    button.type =
      "button";

    return button;
  }


  function brandDisplayName(
    brand
  ) {
    const brandId =
      clean(
        brand?.brandId
      ).toLowerCase();

    const brandName =
      clean(
        brand?.brandName
      ).toLowerCase();

    const displayName = clean(
      brand?.displayName ||
      brand?.publicName ||
      brand?.customerName ||
      brand?.brandName ||
      brand?.brandId
    );

    if (
      brandId.endsWith("-staff") ||
      brandName ===
        "booster juice staff"
    ) {
      return displayName
        .replace(
          /(?:[\s-]+staff)$/i,
          ""
        );
    }

    return displayName;
  }


  /*
    Current CSS uses .hidden.

    Some previous JS also used the HTML
    hidden attribute. Always clear/set both.
  */

  function show(element) {
    if (!element) return;

    element.hidden =
      false;

    element.classList
      .remove("hidden");

    element.removeAttribute(
      "aria-hidden"
    );
  }


  function hide(element) {
    if (!element) return;

    element.hidden =
      true;

    element.classList
      .add("hidden");

    element.setAttribute(
      "aria-hidden",
      "true"
    );
  }


  function setFieldError(
    element,
    message
  ) {
    if (!element) return;

    element.textContent =
      message || "";

    if (message) {
      show(element);
    } else {
      hide(element);
    }
  }


  function scrollToElement(
    element
  ) {
    if (!element) return;

    const top =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      14;

    window.scrollTo({
      top:
        Math.max(0, top),

      behavior:
        "smooth"
    });
  }


  /* =========================================================
     GLOBAL MESSAGES
     ========================================================= */

  let messageTimer = null;


  function setGlobalMessage(
    message,
    type = "info",
    timeout = 5000
  ) {
    const element =
      dom().message;

    if (!element) {
      return;
    }

    if (messageTimer) {
      clearTimeout(
        messageTimer
      );

      messageTimer = null;
    }

    element.classList.remove(
      "is-error",
      "is-success",
      "is-info"
    );

    element.textContent =
      message || "";

    if (!message) {
      hide(element);
      return;
    }

    element.classList.add(
      `is-${type}`
    );

    show(element);

    if (timeout > 0) {
      messageTimer =
        window.setTimeout(
          () => {
            hide(element);
          },
          timeout
        );
    }
  }


  /* =========================================================
     LOADING
     ========================================================= */

  let loadingHideTimer =
    null;


  function setLoading(
    active,
    text = "Loading…"
  ) {
    const d =
      dom();

     
    if (d.loadingText) {
      d.loadingText.textContent =
        text;
    }

    if (active) {
      if (loadingHideTimer) {
        window.clearTimeout(
          loadingHideTimer
        );

        loadingHideTimer =
          null;
      }

      d.loading?.classList.remove(
        "is-exiting"
      );

      show(
        d.loading
      );

      d.loading?.setAttribute(
        "aria-hidden",
        "false"
      );

    } else {
      if (!d.loading) {
        return;
      }

      d.loading.classList.add(
        "is-exiting"
      );

      d.loading?.setAttribute(
        "aria-hidden",
        "true"
      );

      if (loadingHideTimer) {
        window.clearTimeout(
          loadingHideTimer
        );
      }

      loadingHideTimer =
        window.setTimeout(
          () => {
            hide(
              d.loading
            );

            d.loading?.classList.remove(
              "is-exiting"
            );

            loadingHideTimer =
              null;
          },
          240
        );
    }
  }


  /* =========================================================
     SCHOOL GATE
     ========================================================= */

  let schoolGateBound =
    false;


  function bindSchoolGate() {
    if (schoolGateBound) {
      return;
    }

    const d =
      dom();
      

    if (!d.codeForm) {
      return;
    }

    schoolGateBound =
      true;


    d.codeForm
      .addEventListener(
        "submit",
        async event => {
          event.preventDefault();

          const code =
            clean(
              d.codeInput?.value
            );

          if (!code) {
            setFieldError(
              d.codeError,
              "Enter your school code."
            );

            d.codeInput?.focus();

            return;
          }

          setFieldError(
            d.codeError,
            ""
          );

          try {
            await callbacks
              .onSchoolCode?.(
                code
              );

          } catch (error) {
            setFieldError(
              d.codeError,
              error?.message ||
              "That school code could not be verified."
            );
          }
        }
      );
  }


  function showSchoolGate(
    message = ""
  ) {
    const d =
      dom();

    show(
      d.gate
    );

    hide(
      d.ordering
    );

    if (message) {
      setFieldError(
        d.codeError,
        message
      );
    }

    if (d.headerSubtitle) {
      d.headerSubtitle.textContent =
        "Enter your school code to get started.";
    }
  }


  function hideSchoolGate() {
    const d =
      dom();

    hide(
      d.gate
    );

    show(
      d.ordering
    );

    setFieldError(
      d.codeError,
      ""
    );

    if (d.headerSubtitle) {
      d.headerSubtitle.textContent =
        "Choose who you're ordering for, then select a lunch program.";
    }
  }


  function schoolGateError(
    message
  ) {
    showSchoolGate();

    setFieldError(
      dom().codeError,
      message
    );
  }


  /* =========================================================
     SCHOOL BAR
     ========================================================= */

  function renderSchools({
    schools = [],
    currentSchool = null,
    favoriteSchoolId = ""
  } = {}) {
    const d =
      dom();

    if (!currentSchool) {
      return;
    }


    /*
      The Liquid has one element:
        #byl-current-school

      Not separate school-name and city elements.
    */

    if (d.currentSchool) {
      clear(
        d.currentSchool
      );

      const name =
        create(
          "strong",
          "byl-current-school-name",
          currentSchool.schoolName ||
          ""
        );

      d.currentSchool.appendChild(
        name
      );

      if (currentSchool.city) {
        const city =
          create(
            "span",
            "byl-current-school-city",
            currentSchool.city
          );

        d.currentSchool.appendChild(
          city
        );
      }
    }


    /*
      School switcher only appears when
      more than one school is stored.
    */

    if (d.schoolSwitcher) {
      const existingMenu =
        d.schoolSwitcher
          .parentElement
          ?.querySelector(
            ".byl-school-menu"
          );

      existingMenu?.remove();

      clear(
        d.schoolSwitcher
      );

      const validSchools =
        (schools || [])
          .map(
            entry =>
              entry?.school ||
              entry
          )
          .filter(
            school =>
              school?.schoolId
          );


      if (
        validSchools.length > 1
      ) {
        const options =
          document.createDocumentFragment();

        for (
          const school
          of validSchools
        ) {
          const option =
            new Option(
              school.schoolName ||
              school.schoolId,

              school.schoolId
            );

          option.selected =
            school.schoolId ===
            currentSchool.schoolId;

          options
            .appendChild(
              option
            );
        }

        d.schoolSwitcher
          .appendChild(
            options
          );

        show(
          d.schoolSwitcher
        );

        hide(
          d.schoolSwitcher
        );

        const menu =
          renderPriceDropdown({
            placeholder:
              "Change school",

            allowEmpty: false,

            items:
              validSchools,

            value:
              currentSchool.schoolId,

            getValue:
              school =>
                school.schoolId,

            getLabel:
              school =>
                school.schoolName ||
                school.schoolId,

            getPrice:
              school =>
                school.city || "",

            onChange:
              school => {
                if (!school?.schoolId) {
                  return;
                }

                d.schoolSwitcher.value =
                  school.schoolId;

                callbacks
                  .onSchoolChange?.(
                    school.schoolId
                  );

                window.setTimeout(
                  () => scrollToElement(
                    dom().profileSection
                  ),
                  260
                );
              }
          });

        menu.classList.add(
          "byl-school-menu"
        );

        d.schoolSwitcher
          .parentElement
          ?.insertBefore(
            menu,
            d.schoolSwitcher
          );

      } else {
        hide(
          d.schoolSwitcher
        );
      }

      d.schoolSwitcher
        .parentElement
        ?.querySelectorAll(
          ".byl-school-icon-button, .byl-school-icon-group"
        )
        .forEach(
          element =>
            element.remove()
        );

      const iconGroup =
        create(
          "div",
          "byl-school-icon-group"
        );

      if (validSchools.length > 1) {
        const favorite =
          makeButton(
            currentSchool.schoolId ===
              favoriteSchoolId
              ? "♥"
              : "♡",
            `byl-school-icon-button byl-school-favorite${
              currentSchool.schoolId ===
              favoriteSchoolId
                ? " is-active"
                : ""
            }`
          );

        favorite.setAttribute(
          "aria-label",
          "Favorite this school"
        );

        favorite.title =
          "Favorite this school";

        favorite.addEventListener(
          "click",
          () => {
            callbacks
              .onSchoolFavorite?.(
                currentSchool.schoolId
              );
          }
        );

        iconGroup.appendChild(
          favorite
        );
      }

      const remove =
        makeButton(
          "×",
          "byl-school-icon-button byl-school-remove"
        );

      remove.setAttribute(
        "aria-label",
        "Remove this school"
      );

      remove.title =
        "Remove this school";

      remove.addEventListener(
        "click",
        () => {
          const name =
            currentSchool.schoolName ||
            "this school";

          if (
            window.confirm(
              `Remove ${name} from your saved schools?`
            )
          ) {
            callbacks
              .onSchoolDelete?.(
                currentSchool.schoolId
              );
          }
        }
      );

      iconGroup.appendChild(
        remove
      );

      d.schoolSwitcher
        .parentElement
        ?.insertBefore(
          iconGroup,
          d.addSchool || null
        );
    }


    show(
      d.ordering
    );
  }


  /* =========================================================
     ADD SCHOOL MODAL
     ========================================================= */

  function openSchoolModal() {
    const d =
      dom();

    if (
      typeof callbacks
        .onAddSchool ===
      "function"
    ) {
      /*
        Core may handle the modal itself.

        Call it first, but also make sure the
        actual current modal is visible.
      */

      callbacks
        .onAddSchool();
    }

    show(
      d.schoolModal
    );

    d.schoolModal
      ?.setAttribute(
        "aria-hidden",
        "false"
      );

    if (d.addSchoolCode) {
      d.addSchoolCode.value =
        "";

      requestAnimationFrame(
        () =>
          d.addSchoolCode
            .focus()
      );
    }

    setFieldError(
      d.addSchoolError,
      ""
    );
  }


  function closeSchoolModal() {
    const d =
      dom();

    hide(
      d.schoolModal
    );

    d.schoolModal
      ?.setAttribute(
        "aria-hidden",
        "true"
      );

    setFieldError(
      d.addSchoolError,
      ""
    );
  }


  /* =========================================================
     PROFILE DISPLAY HELPERS
     ========================================================= */

  function profileName(
    profile
  ) {
    const full =
      clean(
        `${profile?.firstName || ""} ${
          profile?.lastName || ""
        }`
      );

    if (full) {
      return full;
    }

    return profile?.memberType === "office"
      ? "Office"
      : profile?.memberType === "staff"
        ? "Staff"
        : "Student";
  }


  function profileDetails(
    profile
  ) {
    const details = [];

    if (profile?.memberType === "staff") {
      details.push(
        "Staff"
      );

    } else if (profile?.memberType === "office") {
      details.push(
        "Office"
      );

    } else if (
      profile?.classroom
    ) {
      details.push(
        profile.classroom
      );
    }

    const allergies =
      customer.allergies
        ?.toText?.(
          profile
        ) || "";

    if (allergies) {
      details.push(
        `Allergies: ${allergies}`
      );
    }

    return details.join(
      " • "
    );
  }


  /* =========================================================
     PROFILE LIST

     IMPORTANT:
     We only render SAVED PROFILE CARDS in profile-list.

     We DO NOT create another Add Profile button.

     The Liquid already owns:
       #byl-new-profile
       "+ Add student, staff, or office"
     ========================================================= */

function renderProfiles({
  profiles = [],
  currentProfileId = "",
  reviewPairs = []
} = {}) {
    const d =
      dom();

    if (!d.profileList) {
      return;
    }

    clear(
      d.profileList
    );

    show(
      d.profileSection
    );


    const activeProfiles =
      (profiles || [])
        .filter(
          profile =>
            profile?.active !== false
        );


    if (!activeProfiles.length) {
      const empty =
        create(
          "div",
          "byl-empty-state"
        );

      empty.appendChild(
        create(
          "strong",
          "byl-empty-state-title",
          "No saved students, staff, or office members yet"
        )
      );

      empty.appendChild(
        create(
          "p",
          "byl-empty-state-text",
          "Use the button below to add someone."
        )
      );

      d.profileList
        .appendChild(
          empty
        );

      /*
        The real styled button is directly
        below the profile list in Liquid.
      */

      show(
        d.newProfile
      );

      hide(
        d.brandSection
      );

      hide(
        d.orderSection
      );

      return;
    }
    if (
      Array.isArray(reviewPairs) &&
      reviewPairs.length
    ) {
  const review =
    create(
      "div",
      "byl-profile-review"
    );

  review.appendChild(
    create(
      "strong",
      "byl-profile-review-title",
      "We found older profile information"
    )
  );

  review.appendChild(
    create(
      "p",
      "byl-profile-review-text",
      "These profiles look like they may refer to the same person. Choose what you want to do."
    )
  );

  for (
    const pair
    of reviewPairs
  ) {
    const row =
      create(
        "div",
        "byl-profile-review-row"
      );

    const names =
      create(
        "div",
        "byl-profile-review-names"
      );

    names.appendChild(
      create(
        "strong",
        "",
        profileName(
          pair.savedProfile
        )
      )
    );

    const oldDetails =
      profileDetails(
        pair.historyProfile
      );

    if (oldDetails) {
      names.appendChild(
        create(
          "span",
          "",
          `Old order profile: ${oldDetails}`
        )
      );
    }

    row.appendChild(
      names
    );

    const actions =
      create(
        "div",
        "byl-profile-review-actions"
      );

    const merge =
      makeButton(
        "Merge",
        "byl-secondary-button"
      );

    merge.addEventListener(
      "click",
      () => {
        callbacks
          .onProfileHistoryDecision?.({
            action:
              "merged",

            historyKey:
              pair.historyKey,

            savedProfile:
              pair.savedProfile,

            historyProfile:
              pair.historyProfile
          });
      }
    );

    const keep =
      makeButton(
        "Keep Both",
        "byl-text-button"
      );

    keep.addEventListener(
      "click",
      () => {
        callbacks
          .onProfileHistoryDecision?.({
            action:
              "keep",

            historyKey:
              pair.historyKey,

            savedProfile:
              pair.savedProfile,

            historyProfile:
              pair.historyProfile
          });
      }
    );

    const remove =
      makeButton(
        "Remove Old",
        "byl-text-button"
      );

    remove.addEventListener(
      "click",
      () => {
        callbacks
          .onProfileHistoryDecision?.({
            action:
              "hidden",

            historyKey:
              pair.historyKey,

            savedProfile:
              pair.savedProfile,

            historyProfile:
              pair.historyProfile
          });
      }
    );

    actions.append(
      merge,
      keep,
      remove
    );

    row.appendChild(
      actions
    );

    review.appendChild(
      row
    );
  }

  d.profileList
    .appendChild(
      review
    );
}

    const profileFragment =
      document.createDocumentFragment();

    for (
      const profile
      of activeProfiles
    ) {
      const card =
        makeButton(
          "",
          "byl-profile-option"
        );

      card.dataset.profileId =
        profile.id || "";


      if (
        String(profile.id) ===
        String(currentProfileId)
      ) {
        card.classList.add(
          "is-selected"
        );
      }


      const content =
        create(
          "span",
          "byl-profile-option-content"
        );


      content.appendChild(
        create(
          "strong",
          "byl-profile-option-name",
          profileName(
            profile
          )
        )
      );


      const details =
        profileDetails(
          profile
        );


      if (details) {
        content.appendChild(
          create(
            "span",
            "byl-profile-option-detail",
            details
          )
        );
      }


      card.appendChild(
        content
      );


      const edit =
        makeButton(
          "Edit",
          "byl-text-button byl-profile-edit"
        );


      edit.addEventListener(
        "click",
        event => {
          event.preventDefault();
          event.stopPropagation();

          callbacks
            .onProfileEdit?.(
              profile
            );
        }
      );


      card.appendChild(
        edit
      );
const remove =
  makeButton(
    "Delete",
    "byl-text-button byl-profile-delete"
  );

remove.addEventListener(
  "click",
  event => {
    event.preventDefault();
    event.stopPropagation();

    callbacks
      .onProfileDelete?.(
        profile
      );
  }
);

card.appendChild(
  remove
);

      card.addEventListener(
        "click",
        () => {
          callbacks
            .onProfileSelect?.(
              profile.id
            );

          window.setTimeout(
            () => scrollToElement(
              dom().brandSection
            ),
            260
          );
        }
      );


      profileFragment
        .appendChild(
          card
        );
    }

    d.profileList
      .appendChild(
        profileFragment
      );


    show(
      d.newProfile
    );
  }


  /* =========================================================
     ALLERGY EDITOR

     Keeps the existing Liquid profile form.
     We insert structured allergy controls where the old
     freeform "Allergies or notes" field currently sits.
     ========================================================= */

  const ALLERGY_OPTIONS = [
    "Peanuts",
    "Tree nuts",
    "Dairy",
    "Egg",
    "Gluten",
    "Sesame",
    "Soy",
    "Fish/Shellfish"
  ];


  function ensureAllergyEditor() {
    const d =
      dom();

    if (!d.profileEditor) {
      return null;
    }

    let editor =
      $("byl-allergy-editor");


    if (editor) {
      return editor;
    }


    editor =
      create(
        "div",
        "byl-field byl-field-wide"
      );

    editor.id =
      "byl-allergy-editor";


    editor.appendChild(
      create(
        "label",
        "",
        "Allergies"
      )
    );


    const hint =
      create(
        "div",
        "byl-field-help",
        "Select all that apply."
      );

    editor.appendChild(
      hint
    );


    const options =
      create(
        "div",
        "byl-allergy-options"
      );


    for (
      const allergy
      of ALLERGY_OPTIONS
    ) {
      const label =
        create(
          "label",
          "byl-allergy-option"
        );


      const checkbox =
        create(
          "input"
        );

      checkbox.type =
        "checkbox";

      checkbox.value =
        allergy;

      checkbox.dataset.bylAllergy =
        allergy;


      label.append(
        checkbox,

        create(
          "span",
          "",
          allergy
        )
      );


      options.appendChild(
        label
      );
    }


    /*
      Other
    */

    const otherLabel =
      create(
        "label",
        "byl-allergy-option"
      );


    const otherToggle =
      create(
        "input"
      );

    otherToggle.type =
      "checkbox";

    otherToggle.dataset
      .bylAllergyOtherToggle =
      "true";


    otherLabel.append(
      otherToggle,

      create(
        "span",
        "",
        "Other"
      )
    );


    options.appendChild(
      otherLabel
    );


    editor.appendChild(
      options
    );


    const otherWrap =
      create(
        "div",
        "byl-other-allergy-wrap hidden"
      );

    otherWrap.id =
      "byl-other-allergy-wrap";


    const otherInput =
      create(
        "input"
      );

    otherInput.id =
      "byl-other-allergy";

    otherInput.type =
      "text";

    otherInput.maxLength =
      200;

    otherInput.placeholder =
      "Enter other allergy";


    otherWrap.appendChild(
      otherInput
    );


    editor.appendChild(
      otherWrap
    );


    /*
      Replace visual use of the old notes field,
      but leave it in the DOM for backward
      compatibility.
    */

    const notesField =
      d.profileNotes
        ?.closest(
          ".byl-field"
        );


    if (
      notesField &&
      notesField.parentNode
    ) {
      notesField
        .parentNode
        .insertBefore(
          editor,
          notesField
        );

      hide(
        notesField
      );

    } else {
      d.profileEditor
        .querySelector(
          ".byl-form-grid"
        )
        ?.appendChild(
          editor
        );
    }


    otherToggle
      .addEventListener(
        "change",
        () => {
          if (
            otherToggle.checked
          ) {
            show(
              otherWrap
            );

            otherInput.focus();

          } else {
            hide(
              otherWrap
            );

            otherInput.value =
              "";
          }
        }
      );


    return editor;
  }
    function setProfileAllergies(
    profile
  ) {
    ensureAllergyEditor();

    const normalized =
      customer.profiles
        ?.normalize?.(
          profile || {}
        ) ||
      profile ||
      {};


    const selected =
      new Set(
        (
          normalized.allergies ||
          []
        ).map(
          value =>
            clean(value)
              .toLowerCase()
        )
      );


    document
      .querySelectorAll(
        "[data-byl-allergy]"
      )
      .forEach(
        checkbox => {
          checkbox.checked =
            selected.has(
              clean(
                checkbox.value
              ).toLowerCase()
            );
        }
      );


    const otherToggle =
      document.querySelector(
        "[data-byl-allergy-other-toggle]"
      );


    const otherWrap =
      $("byl-other-allergy-wrap");


    const otherInput =
      $("byl-other-allergy");


    const legacyNotes =
      clean(
        normalized.notes
      );


    const otherValue =
      clean(
        normalized.otherAllergy
      ) ||
      (
        !selected.size
          ? legacyNotes
          : ""
      );


    if (otherToggle) {
      otherToggle.checked =
        Boolean(
          otherValue
        );
    }


    if (otherInput) {
      otherInput.value =
        otherValue;
    }


    if (otherValue) {
      show(
        otherWrap
      );

    } else {
      hide(
        otherWrap
      );
    }
  }


  function readProfileAllergies() {
    const allergies =
      Array
        .from(
          document
            .querySelectorAll(
              "[data-byl-allergy]:checked"
            )
        )
        .map(
          checkbox =>
            checkbox.value
        );


    const otherToggle =
      document.querySelector(
        "[data-byl-allergy-other-toggle]"
      );


    const otherAllergy =
      otherToggle?.checked
        ? clean(
            $("byl-other-allergy")
              ?.value
          )
        : "";


    return {
      allergies,
      otherAllergy
    };
  }


  /* =========================================================
     PROFILE EDITOR
     ========================================================= */

  let editingProfileId =
    "";


  function populateTeachers(
    teachers = [],
    selected = ""
  ) {
    const select =
      dom().classroom;

    if (!select) {
      return;
    }


    clear(
      select
    );


    select.appendChild(
      new Option(
        "Select teacher",
        ""
      )
    );


    const names =
      (teachers || [])
        .map(
          entry => {
            if (
              typeof entry ===
              "string"
            ) {
              return clean(
                entry
              );
            }

            return clean(
              entry?.teacher ||
              entry?.name ||
              entry?.value
            );
          }
        )
        .filter(Boolean);


    /*
      Preserve a teacher saved in an old
      profile even if not currently in list.
    */

    if (
      selected &&
      !names.includes(
        selected
      )
    ) {
      names.unshift(
        selected
      );
    }


    for (
      const teacher
      of names
    ) {
      select.appendChild(
        new Option(
          teacher,
          teacher
        )
      );
    }


    select.value =
      selected || "";
  }


  function updateProfileType() {
    const d =
      dom();

    const isStaff = [
      "staff",
      "office"
    ].includes(
      d.memberType?.value
    );


    if (isStaff) {
      hide(
        d.classroomField
      );

    } else {
      show(
        d.classroomField
      );
    }
  }


  function openProfileEditor({
    profile = null,
    teachers = []
  } = {}) {
    const d =
      dom();

    if (!d.profileEditor) {
      return;
    }


    ensureAllergyEditor();


    const normalized =
      customer.profiles
        ?.normalize?.(
          profile || {}
        ) ||
      profile ||
      {};


    editingProfileId =
      profile?.id ||
      normalized?.id ||
      "";


    if (d.memberType) {
      d.memberType.value = [
        "staff",
        "office"
      ].includes(
        normalized.memberType
      )
        ? normalized.memberType
        : "student";
    }


    if (d.firstName) {
      d.firstName.value =
        normalized.firstName ||
        "";
    }


    if (d.lastName) {
      d.lastName.value =
        normalized.lastName ||
        "";
    }


    populateTeachers(
      teachers,
      normalized.classroom ||
      ""
    );


    setProfileAllergies(
      normalized
    );


    updateProfileType();


    if (d.profileUse) {
      d.profileUse.textContent =
        editingProfileId
          ? "Save & Use"
          : "Use this person";
    }


    show(
      d.profileEditor
    );


    requestAnimationFrame(
      () => {
        d.firstName?.focus();

        d.profileEditor
          ?.scrollIntoView({
            behavior:
              "smooth",

            block:
              "nearest"
          });
      }
    );
  }


  function closeProfileEditor() {
    editingProfileId =
      "";

    hide(
      dom().profileEditor
    );
  }


  function readProfileEditor() {
    const d =
      dom();


    const selectedMemberType =
      d.memberType?.value;

    const memberType = [
      "staff",
      "office"
    ].includes(selectedMemberType)
      ? selectedMemberType
      : "student";


    const firstName =
      clean(
        d.firstName?.value
      );


    const lastName =
      clean(
        d.lastName?.value
      );


    const classroom =
      memberType !==
      "student"
        ? ""
        : clean(
            d.classroom?.value
          );


    if (!firstName) {
      return {
        valid: false,

        error:
          "Enter a first name.",

        profile:
          null
      };
    }


    if (
      memberType ===
        "student" &&
      !classroom
    ) {
      return {
        valid: false,

        error:
          "Select a teacher or classroom.",

        profile:
          null
      };
    }


    const allergy =
      readProfileAllergies();


    const otherToggle =
      document.querySelector(
        "[data-byl-allergy-other-toggle]"
      );


    if (
      otherToggle?.checked &&
      !allergy.otherAllergy
    ) {
      return {
        valid: false,

        error:
          "Enter the other allergy or uncheck Other.",

        profile:
          null
      };
    }


    return {
      valid: true,

      error: "",

      profile: {
        id:
          editingProfileId ||
          "",

        memberType,

        firstName,

        lastName,

        classroom,

        allergies:
          allergy.allergies,

        otherAllergy:
          allergy.otherAllergy,

        active:
          true
      }
    };
  }


  /* =========================================================
     BRANDS
     ========================================================= */

  function renderBrands({
    brands = [],
    currentBrandId = ""
  } = {}) {
    const d =
      dom();

    if (!d.brandList) {
      return;
    }


    clear(
      d.brandList
    );


    const available =
      (brands || [])
        .filter(
          brand =>
            brand?.active !== false
        );


    if (!available.length) {
      d.brandList
        .appendChild(
          create(
            "p",
            "byl-empty-state-text",
            "There are currently no lunch programs available for this school."
          )
        );

      show(
        d.brandSection
      );

      return;
    }

    const fragment =
      document.createDocumentFragment();

    for (
      const brand
      of available
    ) {
      const card =
        makeButton(
          "",
          "byl-brand-option"
        );


      card.dataset.brandId =
        brand.brandId ||
        "";


      if (
        String(brand.brandId) ===
        String(currentBrandId)
      ) {
        card.classList.add(
          "is-selected"
        );
      }


      card.appendChild(
        create(
          "strong",
          "byl-brand-option-name",
          brandDisplayName(
            brand
          )
        )
      );


      const mode =
        engine.brands
          .getOrderMode(
            brand
          );


      const description =
        mode ===
        engine.ORDER_MODES
          .MONTHLY_WEEKDAYS
          ? "Monthly program"
          : "Choose lunch dates";


      card.appendChild(
        create(
          "span",
          "byl-brand-option-meta",
          description
        )
      );


      if (
        !engine.brands
          .isOpen(
            brand
          )
      ) {
        card.disabled =
          true;

        card.classList.add(
          "is-disabled"
        );


        card.appendChild(
          create(
            "span",
            "byl-brand-option-status",
            "Ordering closed"
          )
        );
      }


      card.addEventListener(
        "click",
        () => {
          if (card.disabled) {
            return;
          }

          callbacks
            .onBrandSelect?.(
              brand.brandId
            );

          window.setTimeout(
            () => scrollToElement(
              dom().orderSection
            ),
            360
          );
        }
      );


      fragment
        .appendChild(
          card
        );
    }

    d.brandList
      .appendChild(
        fragment
      );


    show(
      d.brandSection
    );
  }


  /* =========================================================
     PRICE
     ========================================================= */

  function priceFromRecord(
    record
  ) {
    if (!record) {
      return null;
    }

    const direct =
      record.priceCents ??
      record.price_cents ??
      record.variantPriceCents ??
      record.variant_price_cents;

    if (
      direct !== null &&
      direct !== undefined &&
      direct !== ""
    ) {
      const cents =
        Number(direct);

      return Number.isFinite(cents)
        ? cents
        : null;
    }

    const amount =
      record.price ??
      record.amount ??
      record.variantPrice ??
      record.variant_price;

    const numeric =
      Number(amount);

    if (!Number.isFinite(numeric)) {
      return null;
    }

    return numeric > 100
      ? Math.round(numeric)
      : Math.round(numeric * 100);
  }


  function priceLabel(
    variantId,
    record = null
  ) {
    let price =
      services.variants
        .getPrice(
          variantId
        );

    if (
      price === null ||
      price === undefined
    ) {
      price =
        priceFromRecord(
          record
        );
    }

    if (
      price === null ||
      price === undefined
    ) {
      return "";
    }


    return services.money
      .format(
        price
      );
  }


  function itemLabel(
    name,
    variantId,
    record = null
  ) {
    return clean(name);
  }


  function isStaffSmoothieItem(
    item
  ) {
    const itemName =
      clean(
        item?.itemName
      ).toLowerCase();

    return (
      itemName.includes(
        "staff"
      ) &&
      itemName.includes(
        "smoothie"
      )
    );
  }


  function staffSmoothieSize(
    item
  ) {
    const match =
      clean(
        item?.itemName
      ).match(
        /\b(\d+\s*oz)\b/i
      );

    return match
      ? match[1].replace(/\s+/g, "")
      : clean(
          item?.itemName
        );
  }


  function isStaffSmoothieMenu(
    items
  ) {
    return (
      Array.isArray(items) &&
      items.length > 0 &&
      items.every(
        isStaffSmoothieItem
      )
    );
  }


  function customInputConfig(
    item
  ) {
    const config =
      item?.customInput ||
      item?.custom_input ||
      null;

    if (
      config &&
      typeof config === "object"
    ) {
      return config;
    }

    if (clean(config)) {
      return {
        property:
          clean(config)
      };
    }

    if (
      isStaffSmoothieItem(
        item
      )
    ) {
      return {
        property:
          "Smoothie",

        label:
          "Smoothie",

        placeholder:
          "Enter smoothie name",

        required:
          true,

        datalistId:
          "byl-staff-smoothies",

        suggestions: [
          "Acai Avalanche",
          "Bananas-A-Whey",
          "Berry Cream Sensation",
          "Brazilian Thunder",
          "Canadian Colada",
          "Coco Crush",
          "Funky Monkey",
          "Hawaiian Sunset",
          "High Impact Acai",
          "Lemon Berry",
          "Mango Hurricane",
          "Mangosicle",
          "Matcha Monsoon",
          "Mind Over Matcha",
          "Nuttin Better",
          "Oatrageous Mocha",
          "Ocean Mist",
          "Pineapple Freeze",
          "Pirates Nectar",
          "Pomegranate Passion",
          "Strawberry Storm",
          "Strawberry Sunshine",
          "Tropi-Kale",
          "Tropical Tornado",
          "UnBeetable",
          "Very Berry",
          "Wildberry Basil"
        ]
      };
    }

    return null;
  }


  function customInputProperty(
    config
  ) {
    return clean(
      config?.property ||
      config?.name ||
      config?.label ||
      "Order"
    );
  }


  function renderCustomInput({
    item,
    date,
    selected,
    onChange = null
  }) {
    const config =
      customInputConfig(
        item
      );

    if (!config) {
      return null;
    }

    const property =
      customInputProperty(
        config
      );

    if (!property) {
      return null;
    }

    const wrap =
      create(
        "div",
        "byl-date-custom-input"
      );

    const label =
      create(
        "label",
        "byl-date-addons-label",
        clean(config.label) ||
        property
      );

    const inputId =
      `byl-custom-${date}-${property}`
        .toLowerCase()
        .replace(/[^a-z0-9_-]+/g, "-");

    label.setAttribute(
      "for",
      inputId
    );

    const input =
      create(
        "input",
        "byl-text-input"
      );

    input.id =
      inputId;

    input.type =
      "text";

    input.maxLength =
      Number(
        config.maxLength ||
        config.max_length ||
        80
      );

    input.placeholder =
      clean(
        config.placeholder
      ) || "Enter order details";

    input.autocomplete =
      "on";

    input.spellcheck =
      false;

    input.value =
      clean(
        selected?.customInputs
          ?.[property]
      );

    // Use a native select: iPhone datalist suggestions can be unavailable.
    // Keep the text field so staff can still enter custom smoothie requests.
    const suggestions = Array.isArray(config.suggestions)
      ? [...new Set(config.suggestions.map(clean).filter(Boolean))]
      : [];
    let suggestionSelect = null;

    if (suggestions.length) {
      suggestionSelect = create("select", "byl-text-input byl-custom-suggestions");
      suggestionSelect.id = `${inputId}-suggestions`;
      suggestionSelect.setAttribute("aria-label", `Choose ${clean(config.label) || property}`);

      const placeholder = create("option", "", "Choose an option or type below");
      placeholder.value = "";
      suggestionSelect.appendChild(placeholder);

      for (const value of suggestions) {
        const option = create("option", "", value);
        option.value = value;
        suggestionSelect.appendChild(option);
      }

      suggestionSelect.value = suggestions.includes(input.value) ? input.value : "";
      suggestionSelect.addEventListener("change", () => {
        input.value = suggestionSelect.value;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    }

    input.addEventListener(
      "input",
      () => {
        if (suggestionSelect) {
          suggestionSelect.value = suggestions.includes(input.value) ? input.value : "";
        }

        if (onChange) {
          onChange(
            property,
            input.value
          );
        } else {
          callbacks
            .onCustomInputChange?.(
              date,
              property,
              input.value
            );
        }
      }
    );

    wrap.appendChild(label);
    if (suggestionSelect) {
      wrap.appendChild(suggestionSelect);
    }
    wrap.appendChild(input);

    return wrap;
  }


  function renderStaffSmoothieRadios({
    items = [],
    value = "",
    groupKey = "",
    onChange
  } = {}) {
    const group =
      create(
        "div",
        "byl-staff-smoothie-sizes"
      );

    const groupName =
      `byl-staff-smoothie-${clean(groupKey) || Math.random().toString(36).slice(2)}`;

    for (
      const item
      of items
    ) {
      const variantId =
        clean(
          item?.variantId
        );

      if (!variantId) {
        continue;
      }

      const option =
        create(
          "label",
          "byl-staff-smoothie-size"
        );

      const input =
        create("input");

      input.type =
        "radio";

      input.name =
        groupName;

      input.value =
        variantId;

      input.checked =
        String(value || "") ===
        String(variantId);

      input.addEventListener(
        "change",
        () => {
          if (
            input.checked &&
            onChange
          ) {
            onChange(
              item
            );
          }
        }
      );

      option.append(
        input,
        create(
          "span",
          "byl-staff-smoothie-size-label",
          staffSmoothieSize(
            item
          )
        )
      );

      group.appendChild(
        option
      );
    }

    return group;
  }


  function renderPriceDropdown({
    placeholder = "Choose",
    items = [],
    value = "",
    getValue,
    getLabel,
    getPrice,
    allowEmpty = true,
    showPrice = true,
    onChange
  } = {}) {
    const root =
      create(
        "div",
        "byl-price-menu"
      );

    const button =
      makeButton(
        "",
        "byl-price-menu-button"
      );

    const buttonLabel =
      create(
        "span",
        "byl-price-menu-label"
      );

    const buttonPrice =
      create(
        "span",
        "byl-price-menu-price"
      );

    button.append(
      buttonLabel,
      buttonPrice
    );

    const list =
      create(
        "div",
        "byl-price-menu-list"
      );

    list.setAttribute(
      "role",
      "listbox"
    );

    const close =
      () => {
        root.classList.remove(
          "is-open"
        );
      };

    const setButton =
      item => {
        if (!item) {
          buttonLabel.textContent =
            placeholder;

          buttonPrice.textContent =
            "";

          button.classList.add(
            "is-placeholder"
          );

          return;
        }

        buttonLabel.textContent =
          getLabel(item);

        buttonPrice.textContent =
          showPrice
            ? getPrice(item) || ""
            : "";

        button.classList.remove(
          "is-placeholder"
        );
      };

    const selected =
      items.find(
        item =>
          String(
            getValue(item)
          ) ===
          String(value || "")
      ) || null;

    setButton(
      selected
    );

    const emptyOption =
      makeButton(
        "",
        "byl-price-menu-option is-placeholder"
      );

    emptyOption.setAttribute(
      "role",
      "option"
    );

    emptyOption.setAttribute(
      "aria-selected",
      selected
        ? "false"
        : "true"
    );

    emptyOption.append(
      create(
        "span",
        "byl-price-menu-label",
        placeholder
      ),
      create(
        "span",
        "byl-price-menu-price",
        ""
      )
    );

    emptyOption.addEventListener(
      "click",
      () => {
        setButton(
          null
        );

        close();

        onChange?.(
          null
        );
      }
    );

    if (allowEmpty) {
      list.appendChild(
        emptyOption
      );
    }

    for (
      const item
      of items
    ) {
      const option =
        makeButton(
          "",
          "byl-price-menu-option"
        );

      option.setAttribute(
        "role",
        "option"
      );

      option.dataset.value =
        String(
          getValue(item)
        );

      option.setAttribute(
        "aria-selected",
        selected &&
        String(
          getValue(selected)
        ) ===
        String(
          getValue(item)
        )
          ? "true"
          : "false"
      );

      option.append(
        create(
          "span",
          "byl-price-menu-label",
          getLabel(item)
        ),
        create(
          "span",
          "byl-price-menu-price",
          showPrice
            ? getPrice(item) || ""
            : ""
        )
      );

      option.addEventListener(
        "click",
        () => {
          setButton(
            item
          );

          close();

          onChange?.(
            item
          );
        }
      );

      list.appendChild(
        option
      );
    }

    button.addEventListener(
      "click",
      event => {
        event.stopPropagation();

        document
          .querySelectorAll(
            ".byl-price-menu.is-open"
          )
          .forEach(menu => {
            if (menu !== root) {
              menu.classList.remove(
                "is-open"
              );
            }
          });

        root.classList.toggle(
          "is-open"
        );
      }
    );

    root.append(
      button,
      list
    );

    return root;
  }


  /* =========================================================
     GLOBAL OPTIONS / TOPPINGS
     ========================================================= */

  function renderGlobalOptions(
    brand,
    selections
  ) {
    const d =
      dom();

    if (!d.orderOptions) {
      return;
    }


    clear(
      d.orderOptions
    );


    const toppings =
      engine.brands
        .toppingOptions(
          brand
        );


    const generic =
      engine.brands
        .genericOptions(
          brand
        );


    if (
      !toppings.length &&
      !generic.length
    ) {
      hide(
        d.orderOptions
      );

      return;
    }


    /*
      Toppings:
      selected once, applied to every date.
    */

    if (toppings.length) {
      const toppingGroups =
        new Map();


      for (
        const topping
        of toppings
      ) {
        const group =
          topping.group ||
          "Toppings";


        if (!toppingGroups.has(group)) {
          toppingGroups.set(
            group,
            []
          );
        }


        toppingGroups.get(group)
          .push(topping);
      }


      for (
        const [
          group,
          groupToppings
        ]
        of toppingGroups.entries()
      ) {
        const section =
          create(
            "div",
            "byl-option-group"
          );


        section.appendChild(
          create(
            "div",
            "byl-option-group-title",
            group
          )
        );


        section.appendChild(
          create(
            "p",
            "byl-option-group-help",
            "These selections apply to matching menu items on all selected dates."
          )
        );


        const pills =
          create(
            "div",
            "byl-option-pills"
          );


        for (
          const topping
          of groupToppings
        ) {
          const selected =
            (
              selections.toppings ||
              []
            ).includes(
              topping.value
            );


          const button =
            makeButton(
              topping.value,
              `byl-option-pill${
                selected
                  ? " is-selected"
                  : ""
              }`
            );


          button.addEventListener(
            "click",
            () => {
              callbacks
                .onToppingToggle?.(
                  topping.value
                );

              scrollAfterOrderInput(
                "",
                "summary"
              );
            }
          );


          pills.appendChild(
            button
          );
        }


        section.appendChild(
          pills
        );


        d.orderOptions
          .appendChild(
            section
          );
      }
    }


    /*
      Other generic groups.
    */

    const groups =
      new Map();


    for (
      const option
      of generic
    ) {
      const group =
        option.group ||
        option.type ||
        "Options";


      if (!groups.has(group)) {
        groups.set(
          group,
          []
        );
      }


      groups.get(group)
        .push(
          option
        );
    }


    for (
      const [
        group,
        options
      ]
      of groups.entries()
    ) {
      const section =
        create(
          "div",
          "byl-option-group"
        );


      section.appendChild(
        create(
          "div",
          "byl-option-group-title",
          group
        )
      );


      const pills =
        create(
          "div",
          "byl-option-pills"
        );


      for (
        const option
        of options
      ) {
        const selected =
          selections.options
            ?.[group] ===
          option.value;


        const button =
          makeButton(
            option.value,
            `byl-option-pill${
              selected
                ? " is-selected"
                : ""
            }`
          );


        button.addEventListener(
          "click",
          () => {
            callbacks
              .onOptionChange?.(
                group,
                option.value
              );

            scrollAfterOrderInput(
              "",
              "summary"
            );
          }
        );


        pills.appendChild(
          button
        );
      }


      section.appendChild(
        pills
      );


      d.orderOptions
        .appendChild(
          section
        );
    }


    show(
      d.orderOptions
    );
  }
    /* =========================================================
     DATE ORDERING
     ========================================================= */

  function appendDateCycleBadge(container, brand, date) {
    const hasPreviousDates = (brand?.dates || []).some(
      serviceDate => brand.dateMenus?.[serviceDate]?.includes("previous")
    );
    if (!hasPreviousDates) return;

    const isPrevious = brand.dateMenus?.[date]?.includes("previous");
    container.appendChild(create(
      "span",
      `byl-date-cycle-badge byl-date-cycle-badge--${isPrevious ? "previous" : "new"}`,
      isPrevious ? "Previous dates" : "New dates"
    ));
  }

  function renderDateOrdering({
    school,
    profile,
    brand,
    selections,
    history = [],
    overrides = new Set()
  }) {
    const d =
      dom();


    clear(
      d.workspace
    );


    const dates =
      engine.cutoffs
        .openDates(
          brand
        );

    const fragment =
      document.createDocumentFragment();


    if (!dates.length) {
      d.workspace
        ?.appendChild(
          create(
            "p",
            "byl-empty-state-text",
            "There are no open ordering dates for this program."
          )
        );

      return;
    }

    const selectedDates =
      dates
        .filter(
          date =>
            !brand.dateMenus?.[date]?.includes("previous") &&
            selections.dates
              ?.[date]
              ?.variantId
        );

    const copySourceDate =
      selectedDates.length
        ? selectedDates[
            selectedDates.length - 1
          ]
        : "";

    for (
      const date
      of dates
    ) {
      const mains = engine.brands.mainItems(brand, profile, date);
      const addOns = engine.brands.addOnItems(brand, profile, date);

      const existing =
        engine.history
          .findExisting({
            orders:
              history,

            profile,

            school,

            brand,

            serviceDate:
              date
          });


      const override =
        overrides instanceof Set
          ? overrides.has(
              date
            )
          : Boolean(
              overrides?.[date]
            );


      const selected =
        selections.dates
          ?.[date] ||
        null;


      const row =
        create(
          "div",
          "byl-date-row"
        );

      row.dataset.bylServiceDate =
        date;


      const heading =
        create(
          "div",
          "byl-date-info"
        );


      heading.appendChild(
        create(
          "strong",
          "byl-date-title",

          engine.helpers
            .formatDate(
              date
            )
        )
      );


      appendDateCycleBadge(heading, brand, date);

      const cutoff =
        engine.cutoffs
          .label(
            date,
            brand
          );


      if (cutoff) {
        heading.appendChild(
          create(
            "span",
            "byl-date-cutoff",
            `Order by ${cutoff}`
          )
        );
      }


      row.appendChild(
        heading
      );


      /*
        Existing active order:
        block until Order Anyway.
      */

      if (
        existing &&
        !override
      ) {
        row.classList.add(
          "is-existing-order"
        );


        const warning =
          create(
            "div",
            "byl-existing-order-warning"
          );


        warning.appendChild(
          create(
            "strong",
            "",
            "Already ordered"
          )
        );


        warning.appendChild(
          create(
            "span",
            "",

            existing.orderName
              ? `An active order already exists (${existing.orderName}).`
              : "An active order already exists for this date."
          )
        );


        const orderedItem =
          existingOrderTitle(
            existing
          );

        if (orderedItem) {
          warning.appendChild(
            create(
              "span",
              "byl-existing-order-item",
              orderedItem
            )
          );
        }


        const anyway =
          makeButton(
            "Order Anyway",
            "byl-secondary-button"
          );


        anyway.addEventListener(
          "click",
          () => {
            callbacks
              .onOrderAnyway?.(
                date
              );
          }
        );


        warning.appendChild(
          anyway
        );


        row.appendChild(
          warning
        );


        fragment
          .appendChild(
            row
          );


        continue;
      }


      /*
        Main lunch selector.
      */

      const selectWrap =
        create(
          "div",
          "byl-date-control"
        );

      const onMainChange =
        item => {
          callbacks
            .onMainSelect?.(
              date,
              item
            );

          scrollAfterOrderInput(
            date,
            "next"
          );
        };

      if (
        isStaffSmoothieMenu(
          mains
        )
      ) {
        selectWrap.appendChild(
          renderStaffSmoothieRadios({
            items:
              mains,

            value:
              selected?.variantId ||
              "",

            groupKey:
              date,

            onChange:
              onMainChange
          })
        );
      } else {
        selectWrap.appendChild(
          renderPriceDropdown({
            placeholder:
              "Choose lunch",

            items:
              mains,

            value:
              selected?.variantId ||
              "",

            getValue:
              item =>
                item.variantId,

            getLabel:
              item =>
                item.itemName,

            getPrice:
              item =>
                priceLabel(
                  item.variantId,
                  item
                ),

            onChange:
              onMainChange
          })
        );
      }


      row.appendChild(
        selectWrap
      );


      const selectedItem =
        selected?.variantId
          ? mains.find(
              item =>
                String(
                  item.variantId
                ) ===
                String(
                  selected.variantId
                )
            ) || null
          : null;

      const customInput =
        renderCustomInput({
          item:
            selectedItem,

          date,

          selected
        });

      if (customInput) {
        row.appendChild(
          customInput
        );
      }


      /*
        ADD-ONS ARE PER DATE.

        Source of truth:
        School Items with Item Type Add-on.
      */

      if (
        selected?.variantId &&
        addOns.length
      ) {
        const addonWrap =
          create(
            "div",
            "byl-date-addons"
          );


        addonWrap.appendChild(
          create(
            "span",
            "byl-date-addons-label",
            "Add-ons"
          )
        );


        const addonPills =
          create(
            "div",
            "byl-option-pills"
          );


        for (
          const addon
          of addOns
        ) {
          const selectedAddon =
            (
              selected.addOns ||
              []
            ).some(
              current =>
                String(
                  current.variantId
                ) ===
                String(
                  addon.variantId
                )
            );


          const button =
            makeButton(
              itemLabel(
                addon.itemName,
                addon.variantId,
                addon
              ),

              `byl-option-pill${
                selectedAddon
                  ? " is-selected"
                  : ""
              }`
            );


          button.addEventListener(
            "click",
            () => {
              callbacks
                .onAddOnToggle?.(
                  date,
                  addon
                );

              scrollAfterOrderInput(
                date,
                "summary"
              );
            }
          );


          addonPills.appendChild(
            button
          );
        }


        addonWrap.appendChild(
          addonPills
        );


        row.appendChild(
          addonWrap
        );
      }

      if (
        selected?.variantId &&
        date === copySourceDate
      ) {
        const copyAction =
          renderCopyForwardAction({
            date,
            dates,
            selections,
            brand,
            school,
            profile,
            history,
            overrides
          });

        if (copyAction) {
          row.appendChild(
            copyAction
          );
        }
      }


      fragment
        .appendChild(
          row
        );
    }

    d.workspace
      ?.appendChild(
        fragment
      );
  }


  function renderCopyForwardAction({
    date,
    dates = [],
    selections,
    brand,
    school,
    profile,
    history = [],
    overrides = new Set()
  } = {}) {
    if (brand?.dateMenus?.[date]?.includes("previous")) {
      return null;
    }

    const futureDates =
      (dates || [])
        .filter(
          nextDate =>
            String(nextDate) > String(date) &&
            !selections
              ?.dates
              ?.[nextDate]
              ?.variantId &&
            engine.cutoffs
              .dateIsOpen(
                nextDate,
                brand
              )
        )
        .filter(
          nextDate => {
            const existing =
              engine.history
                .findExisting({
                  orders:
                    history,

                  profile,

                  school,

                  brand,

                  serviceDate:
                    nextDate
                });

            if (!existing) {
              return true;
            }

            return overrides instanceof Set
              ? overrides.has(
                  nextDate
                )
              : Boolean(
                  overrides?.[nextDate]
        );
          }
        );

    if (!futureDates.length) {
      return null;
    }

    const wrap =
      create(
        "div",
        "byl-copy-forward"
      );

    const button =
      makeButton(
        "Copy to future dates",
        "byl-secondary-button byl-copy-forward-button"
      );

    button.addEventListener(
      "click",
      () => {
        callbacks
          .onCopyDateForward?.(
            date
          );
      }
    );

    wrap.appendChild(
      button
    );

    if (futureDates.length) {
      wrap.appendChild(
        create(
          "span",
          "",
          `${futureDates.length} date${futureDates.length === 1 ? "" : "s"}`
        )
      );
    }

    return wrap;
  }
  /* =========================================================
     CALENDAR ORDERING
     ========================================================= */

  function renderCalendarOrdering({
    school,
    profile,
    brands = [],
    history = [],
    overrides = new Set(),
    selections = {},
    cartBusy = false
  } = {}) {
    const d =
      dom();

    if (
      !d.calendarGrid ||
      !school ||
      !profile
    ) {
      return;
    }


    clear(
      d.calendarGrid
    );


    /*
      Show who / where we're ordering for.
    */

    if (
      d.calendarProfileSummary
    ) {
      d.calendarProfileSummary
        .textContent =
          `${profileName(profile)} • ${
            school.schoolName ||
            school.name ||
            ""
          }`;
    }


    const calendarBrands =
      (brands || [])
        .filter(
          brand =>
            brand?.active !== false &&
            engine.brands
              .getOrderMode(
                brand
              ) !==
              engine.ORDER_MODES
                .MONTHLY_WEEKDAYS
        );

    const brandSelections =
      selections &&
      typeof selections === "object"
        ? selections
        : {};

    const dateMap =
      new Map();


    for (
      const brand
      of calendarBrands
    ) {
      const dates =
        Array.isArray(
          brand?.dates
        )
          ? brand.dates
          : [];


      for (
        const date
        of dates
      ) {
        if (
          !dateMap.has(
            date
          )
        ) {
          dateMap.set(
            date,
            []
          );
        }


        dateMap.get(
          date
        ).push(
          brand
        );
      }
    }


    const dates =
      Array.from(
        dateMap.keys()
      ).sort();


    if (
      !dates.length
    ) {
      updateCalendarSummary({
        brands:
          [],

        selections:
          {},

        cartBusy
      });

      d.calendarGrid
        .appendChild(
          create(
            "p",
            "byl-empty-state-text",
            "There are currently no open calendar ordering dates."
          )
        );

      return;
    }

    updateCalendarSummary({
      brands:
        calendarBrands,

      selections:
        brandSelections,

      cartBusy
    });

    const calendarDates =
      buildCalendarGridDates(
        dates,
        8
      );

    const fragment =
      document.createDocumentFragment();

    for (
      const date
      of calendarDates
    ) {
      const day =
        create(
          "div",
          "byl-calendar-day"
        );

      if (
        dateIsPast(
          date
        )
      ) {
        day.classList.add(
          "is-past"
        );
      }


      const heading =
        create(
          "div",
          "byl-calendar-day-heading"
        );


      heading.appendChild(
        create(
          "strong",
          "byl-calendar-day-title",

          engine.helpers
            .formatDate(
              date
            )
        )
      );


      day.appendChild(
        heading
      );


      const brandsForDate =
        dateMap.get(
          date
        ) || [];

      if (!brandsForDate.length) {
        day.appendChild(
          create(
            "span",
            "byl-calendar-empty",
            "-"
          )
        );

        fragment
          .appendChild(
            day
          );

        continue;
      }


      for (
        const brand
        of brandsForDate
      ) {
        const existing =
          engine.history
            .findExisting({
              orders:
                history,

              profile,

              school,

              brand,

              serviceDate:
                date
            });

        const override =
          overrides instanceof Set
            ? overrides.has(
                date
              )
            : Boolean(
                overrides?.[date]
              );

        const isOpen =
          engine.cutoffs
            .dateIsOpen(
              date,
              brand
            );


        const row =
          create(
            "div",
            `byl-calendar-brand${
              (existing &&
              !override) ||
              !isOpen
                ? " is-existing-order"
                : ""
            }`
          );

        if (!isOpen) {
          row.classList.add(
            "is-unavailable"
          );
        }


        const name =
          create(
            "strong",
            "byl-calendar-brand-name",

            brandDisplayName(
              brand
            )
          );


        row.appendChild(
          name
        );

        appendDateCycleBadge(row, brand, date);


        if (
          existing &&
          !override
        ) {
          const status =
            makeButton(
              "Already ordered"
            );

          status.className =
            "byl-calendar-brand-status byl-calendar-order-anyway";

          status.addEventListener(
            "click",
            () => {
              callbacks
                .onOrderAnyway?.(
                  date
                );
            }
          );

          row.appendChild(
            status
          );

          row.appendChild(
            renderCalendarExistingOrder(
              existing
            )
          );

          const anyway =
            makeButton(
              "Order anyway",
              "byl-secondary-button byl-calendar-anyway-button"
            );

          anyway.addEventListener(
            "click",
            () => {
              callbacks
                .onOrderAnyway?.(
                  date
                );
            }
          );

          row.appendChild(
            anyway
          );

        } else if (!isOpen) {
          row.appendChild(
            create(
              "span",
              "byl-calendar-brand-status",
              "Closed"
            )
          );

          row.appendChild(
            create(
              "span",
              "byl-calendar-order-detail",
              "Ordering is closed for this date."
            )
          );

        } else {
          row.appendChild(
            create(
              "span",
              "byl-calendar-brand-status",
              "Available"
            )
          );

          row.appendChild(
            renderCalendarBrandControl({
              brand,
              date,
              profile,
              selections:
                brandSelections[
                  brand.brandId
                ]
            })
          );
        }


        day.appendChild(
          row
        );
      }

      const dayOptions =
        renderCalendarDayOptions({
          date,

          brands:
            brandsForDate,

          selections:
            brandSelections
        });

      if (dayOptions) {
        day.appendChild(
          dayOptions
        );
      }


      fragment
        .appendChild(
          day
        );
    }

    d.calendarGrid
      .appendChild(
        fragment
      );
  }


  function buildCalendarGridDates(
    dates,
    weeks = 8
  ) {
    if (
      !Array.isArray(dates) ||
      !dates.length
    ) {
      return [];
    }

    const today =
      new Date();

    today.setHours(
      0,
      0,
      0,
      0
    );

    const monday =
      new Date(
        today.getTime()
      );

    const offset =
      (monday.getDay() + 6) % 7;

    monday.setDate(
      monday.getDate() -
      offset
    );

    const result = [];

    for (
      let week = 0;
      week < weeks;
      week += 1
    ) {
      for (
        let weekday = 0;
        weekday < 5;
        weekday += 1
      ) {
        const next =
          new Date(
            monday.getTime()
          );

        next.setDate(
          monday.getDate() +
          week * 7 +
          weekday
        );

        result.push(
          toLocalDateIso(
            next
          )
        );
      }
    }

    return result;
  }


  function dateIsPast(
    isoDate
  ) {
    const date =
      parseLocalDate(
        isoDate
      );

    if (!date) {
      return false;
    }

    const today =
      new Date();

    today.setHours(
      0,
      0,
      0,
      0
    );

    return date < today;
  }


  function parseLocalDate(
    isoDate
  ) {
    const match =
      String(
        isoDate || ""
      ).match(
        /^(\d{4})-(\d{2})-(\d{2})$/
      );

    if (!match) {
      return null;
    }

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }


  function scrollAfterOrderInput(
    serviceDate = "",
    target = "next"
  ) {
    const run =
      () => {
        const rows =
          Array.from(
            document.querySelectorAll(
              "#byl-order-section [data-byl-service-date]"
            )
          );

        const current =
          serviceDate
            ? rows.find(
                row =>
                  row.dataset
                    .bylServiceDate ===
                  serviceDate
              )
            : null;

        const element =
          target === "next" && current
            ? (
                current.nextElementSibling ||
                dom().orderSummary
              )
            : dom().orderSummary;

        if (!element) {
          return;
        }

        const top =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          Math.max(
            12,
            Math.round(
              window.innerHeight * 0.22
            )
          );

        window.scrollTo({
          top:
            Math.max(0, top),

          behavior:
            "smooth"
        });
      };

    window.setTimeout(run, 260);
    window.setTimeout(run, 700);
  }


  function toLocalDateIso(
    date
  ) {
    return [
      date.getFullYear(),
      String(
        date.getMonth() + 1
      ).padStart(2, "0"),
      String(
        date.getDate()
      ).padStart(2, "0")
    ].join("-");
  }


  function renderCalendarExistingOrder(
    line
  ) {
    const detail =
      create(
        "div",
        "byl-calendar-order-detail"
      );

    const title =
      existingOrderTitle(
        line
      );

    detail.appendChild(
      create(
        "strong",
        "",
        title ||
        "Order found"
      )
    );

    const extras =
      existingOrderExtras(
        line
      );

    if (extras) {
      detail.appendChild(
        create(
          "span",
          "",
          extras
        )
      );
    }

    return detail;
  }


  function cleanExistingOrderDisplay(
    value
  ) {
    return clean(value)
      .replace(
        /\s*\/\s*\$?\d+(?:\.\d{2})?\s*(?:CAD|USD)?\s*$/i,
        ""
      )
      .replace(
        /\s*[-–]\s*\$?\d+(?:\.\d{2})?\s*(?:CAD|USD)?\s*$/i,
        ""
      )
      .replace(
        /\s+\$?\d+(?:\.\d{2})?\s*(?:CAD|USD)?\s*$/i,
        ""
      )
      .trim();
  }


  function existingOrderTitle(
    line
  ) {
    const props =
      line?.properties &&
      typeof line.properties ===
        "object"
        ? line.properties
        : {};

    const candidates =
      [
        props.Item,
        props.Lunch,
        props.Product,
        props.Flavour,
        props.Smoothie,
        line?.itemName,
        line?.variantTitle,
        line?.variant_title,
        line?.productTitle,
        line?.product_title,
        line?.itemTitle,
        line?.item_title,
        line?.title
      ];

    for (
      const candidate
      of candidates
    ) {
      const text =
        cleanExistingOrderDisplay(
          candidate
        );

      if (text) {
        return text;
      }
    }

    return "";
  }


  function existingOrderExtras(
    line
  ) {
    const props =
      line?.properties &&
      typeof line.properties ===
        "object"
        ? line.properties
        : {};

    const values =
      [
        props.Size
          ? `Size: ${props.Size}`
          : "",
        props.Toppings
          ? `Toppings: ${props.Toppings}`
          : "",
        props.Flavour
          ? `Flavour: ${props.Flavour}`
          : "",
        props.Smoothie
          ? `Smoothie: ${props.Smoothie}`
          : "",
        props.AddOnFor
          ? `Add-on for ${props.AddOnFor}`
          : "",
        line?.orderName
          ? `Order ${line.orderName}`
          : ""
      ];

    return values
      .map(clean)
      .filter(Boolean)
      .join(" • ");
  }


  function updateCalendarSummary({
    brands = [],
    selections = {},
    cartBusy = false
  } = {}) {
    const d =
      dom();

    let lineCount = 0;
    let totalPrice = 0;
    let unknownPrices = false;

    for (
      const brand
      of brands
    ) {
      const total =
        engine.pricing
          .total({
            brand,
            selections:
              selections[
                brand.brandId
              ] ||
              engine.selections
                .create()
          });

      lineCount +=
        Number(
          total.lineCount || 0
        );

      totalPrice +=
        Number(
          total.total || 0
        );

      unknownPrices =
        unknownPrices ||
        total.unknownPrices;
    }

    if (d.calendarCount) {
      d.calendarCount.textContent =
        String(lineCount);
    }

    if (d.calendarTotal) {
      d.calendarTotal.textContent =
        unknownPrices
          ? (
              totalPrice > 0
                ? `${services.money.format(totalPrice)}+`
                : "Loading price..."
            )
          : services.money
              .format(
                totalPrice
              );
    }

    if (d.calendarSubmit) {
      d.calendarSubmit.disabled =
        Boolean(
          cartBusy ||
          lineCount === 0
        );

      d.calendarSubmit.textContent =
        cartBusy
          ? "Adding..."
          : "Add All to Cart";
    }
  }


  function renderCalendarBrandControl({
    brand,
    date,
    profile,
    selections
  }) {
    const safe =
      engine.selections
        .ensure(
          selections
        );

    const selected =
      safe.dates?.[
        date
      ] || null;

    const mains =
      engine.brands
        .mainItems(
          brand,
          profile,
          date
        );

    const addOns =
      engine.brands
        .addOnItems(
          brand,
          profile,
          date
        );

    const control =
      create(
        "div",
        "byl-calendar-brand-control"
      );

    const onMainChange =
      item => {
        callbacks
          .onCalendarChange?.({
            type:
              "main",

            brandId:
              brand.brandId,

            date,

            item
          });
      };

    control.appendChild(
      isStaffSmoothieMenu(
        mains
      )
        ? renderStaffSmoothieRadios({
            items:
              mains,

            value:
              selected?.variantId ||
              "",

            groupKey:
              `${brand.brandId}-${date}`,

            onChange:
              onMainChange
          })
        : renderPriceDropdown({
            placeholder:
              "Choose lunch",

            items:
              mains,

            value:
              selected?.variantId ||
              "",

            getValue:
              item =>
                item.variantId,

            getLabel:
              item =>
                item.itemName,

            getPrice:
              item =>
                priceLabel(
                  item.variantId,
                  item
                ),

            onChange:
              onMainChange
          })
    );

    const selectedItem =
      selected?.variantId
        ? mains.find(
            item =>
              String(
                item.variantId
              ) ===
              String(
                selected.variantId
              )
          ) || null
        : null;

    const customInput =
      renderCustomInput({
        item:
          selectedItem,

        date,

        selected,

        onChange:
          (property, value) => {
            callbacks
              .onCalendarChange?.({
                type:
                  "customInput",

                brandId:
                  brand.brandId,

                date,

                property,

                value
              });
          }
      });

    if (customInput) {
      control.appendChild(
        customInput
      );
    }

    if (
      selected?.variantId &&
      addOns.length
    ) {
      const addonGroup =
        create(
          "div",
          "byl-calendar-addons"
        );

      addonGroup.appendChild(
        create(
          "span",
          "byl-date-addons-label",
          "Add-ons"
        )
      );

      const pills =
        create(
          "div",
          "byl-option-pills"
        );

      for (
        const addon
        of addOns
      ) {
        const selectedAddon =
          (
            selected.addOns ||
            []
          ).some(
            current =>
              String(
                current.variantId
              ) ===
              String(
                addon.variantId
              )
          );

        const button =
          makeButton(
            itemLabel(
              addon.itemName,
              addon.variantId,
              addon
            ),

            `byl-option-pill${
              selectedAddon
                ? " is-selected"
                : ""
            }`
          );

        button.addEventListener(
          "click",
          () => {
            callbacks
              .onCalendarChange?.({
                type:
                  "addon",

                brandId:
                  brand.brandId,

                date,

                item:
                  addon
              });
          }
        );

        pills.appendChild(
          button
        );
      }

      addonGroup.appendChild(
        pills
      );

      control.appendChild(
        addonGroup
      );
    }

    return control;
  }


  function renderCalendarDayOptions({
    date,
    brands = [],
    selections = {}
  } = {}) {
    const wrap =
      create(
        "div",
        "byl-calendar-day-options"
      );

    for (
      const brand
      of brands
    ) {
      const safe =
        engine.selections
          .ensure(
            selections[
              brand.brandId
            ]
          );

      if (
        !safe.dates?.[
          date
        ]
      ) {
        continue;
      }

      const toppings =
        engine.brands
          .toppingOptions(
            brand
          );

      const generic =
        engine.brands
          .genericOptions(
            brand
          );

      if (
        !toppings.length &&
        !generic.length
      ) {
        continue;
      }

      const group =
        create(
          "div",
          "byl-calendar-option-group"
        );

      group.appendChild(
        create(
          "strong",
          "byl-calendar-option-title",
          brandDisplayName(
            brand
          ) ||
          "Options"
        )
      );

      if (toppings.length) {
        group.appendChild(
          renderCalendarPills({
            brand,
            safe,
            options:
              toppings,
            type:
              "topping"
          })
        );
      }

      const groups =
        new Map();

      for (
        const option
        of generic
      ) {
        const name =
          option.group ||
          option.type ||
          "Options";

        if (!groups.has(name)) {
          groups.set(
            name,
            []
          );
        }

        groups.get(name)
          .push(option);
      }

      for (
        const [
          name,
          options
        ]
        of groups
      ) {
        group.appendChild(
          create(
            "span",
            "byl-calendar-option-label",
            name
          )
        );

        group.appendChild(
          renderCalendarPills({
            brand,
            safe,
            options,
            type:
              "option",
            group:
              name
          })
        );
      }

      wrap.appendChild(
        group
      );
    }

    return wrap.children.length
      ? wrap
      : null;
  }


  function renderCalendarPills({
    brand,
    safe,
    options = [],
    type,
    group = ""
  }) {
    const pills =
      create(
        "div",
        "byl-option-pills"
      );

    for (
      const option
      of options
    ) {
      const value =
        option.value;

      const selected =
        type === "topping"
          ? (
              safe.toppings || []
            ).includes(value)
          : safe.options?.[
              group
            ] === value;

      const button =
        makeButton(
          value,
          `byl-option-pill${
            selected
              ? " is-selected"
              : ""
          }`
        );

      button.addEventListener(
        "click",
        () => {
          callbacks
            .onCalendarChange?.({
              type,

              brandId:
                brand.brandId,

              group,

              value
            });
        }
      );

      pills.appendChild(
        button
      );
    }

    return pills;
  }

  /* =========================================================
     MONTHLY WEEKDAY ORDERING / DAILY MILK
     ========================================================= */

  function renderMonthlyOrdering({
    school,
    profile,
    brand,
    selections,
    history = [],
    overrides = new Set(),
    activePeriodId = ""
  }) {
    const d =
      dom();


    clear(
      d.workspace
    );


    const periods =
      engine.cutoffs
        .openPeriods(
          brand
        );


    if (!periods.length) {
      d.workspace
        ?.appendChild(
          create(
            "p",
            "byl-empty-state-text",
            "There are no monthly ordering periods currently open."
          )
        );

      return;
    }


    const activePeriod =
      periods.find(
        period =>
          period.periodId ===
          activePeriodId
      ) ||
      periods[0];


    /*
      Month tabs.
    */

    const tabs =
      create(
        "div",
        "byl-period-tabs"
      );


    for (
      const period
      of periods
    ) {
      const tab =
        makeButton(
          period.label,
          `byl-period-tab${
            period.periodId ===
            activePeriod.periodId
              ? " is-selected"
              : ""
          }`
        );


      tab.addEventListener(
        "click",
        () => {
          callbacks
            .onPeriodChange?.(
              period.periodId
            );
        }
      );


      tabs.appendChild(
        tab
      );
    }


    d.workspace
      ?.appendChild(
        tabs
      );


    /*
      Weekday choices.
    */

    const rows =
      engine.monthly
        .rows(
          brand,
          activePeriod.periodId
        );


    const list =
      create(
        "div",
        "byl-weekday-list"
      );


    for (
      const row
      of rows
    ) {
      const item =
        create(
          "div",
          "byl-weekday-row"
        );

      item.dataset.bylServiceDate =
        `${activePeriod.periodId}:${row.label}`;


      item.appendChild(
        create(
          "strong",
          "byl-weekday-name",
          row.label
        )
      );


      /*
        Daily Milk uses a synthetic service date.

        Example:
        <periodId>:Monday

        This lets the duplicate-order engine
        treat each weekday as its own service.
      */

      const serviceDate =
        `${activePeriod.periodId}:${row.label}`;


      const existing =
        engine.history
          .findExisting({
            orders:
              history,

            profile,

            school,

            brand,

            serviceDate
          });


      const override =
        overrides instanceof Set
          ? overrides.has(
              serviceDate
            )
          : Boolean(
              overrides?.[
                serviceDate
              ]
            );


      /*
        Existing active Daily Milk order.

        This behaves exactly like the regular
        date-ordering duplicate protection.
      */

      if (
        existing &&
        !override
      ) {
        item.classList.add(
          "is-existing-order"
        );


        const warning =
          create(
            "div",
            "byl-existing-order-warning"
          );


        warning.appendChild(
          create(
            "strong",
            "",
            "Already ordered"
          )
        );


        warning.appendChild(
          create(
            "span",
            "",

            existing.orderName
              ? `An active order already exists (${existing.orderName}).`
              : `An active order already exists for ${row.label}.`
          )
        );


        const orderedItem =
          existingOrderTitle(
            existing
          );

        if (orderedItem) {
          warning.appendChild(
            create(
              "span",
              "byl-existing-order-item",
              orderedItem
            )
          );
        }


        const anyway =
          makeButton(
            "Order Anyway",
            "byl-secondary-button"
          );


        anyway.addEventListener(
          "click",
          () => {
            callbacks
              .onOrderAnyway?.(
                serviceDate
              );
          }
        );


        warning.appendChild(
          anyway
        );


        item.appendChild(
          warning
        );


        list.appendChild(
          item
        );


        continue;
      }


      /*
        Normal Daily Milk choices.
      */

      const choices =
        engine.monthly
          .choices(
            brand,
            row
          );


      const current =
        selections.periods
          ?.[activePeriod.periodId]
          ?.[row.label];


      item.appendChild(
        renderPriceDropdown({
          placeholder:
            "Choose an option",

          items:
            choices,

          value:
            current?.choice ||
            "",

          getValue:
            choice =>
              choice.value,

          getLabel:
            choice =>
              choice.value,

          getPrice:
            choice =>
              choice.submit === false
                ? ""
                : priceLabel(
                    row.variantId,
                    row
                  ),

          onChange:
            choice => {
              callbacks
                .onPeriodChoice?.(
                  activePeriod.periodId,
                  row.label,
                  choice
                );

              scrollAfterOrderInput(
                `${activePeriod.periodId}:${row.label}`,
                "next"
              );
            }
        })
      );


      list.appendChild(
        item
      );
    }


    d.workspace
      ?.appendChild(
        list
      );
  }


  /* =========================================================
     ORDER SUMMARY

     DO NOT replace #byl-order-summary.
     DO NOT create a second cart button.

     Liquid already owns both.
     ========================================================= */

  function renderSummary({
    brand,
    selections,
    activePeriodId = "",
    cartBusy = false
  } = {}) {
    const d =
      dom();


    if (
      !brand ||
      !d.orderTotal ||
      !d.addToCart
    ) {
      return;
    }


    const total =
      engine.pricing
        .total({
          brand,
          selections,
          periodId:
            activePeriodId
        });


    d.orderTotal.textContent =
      total.formatted ||
      "$0.00";


    d.addToCart.disabled =
      Boolean(
        cartBusy ||
        total.lineCount === 0
      );


    d.addToCart.textContent =
      cartBusy
        ? "Adding..."
        : "Add to Cart";
  }


  /* =========================================================
     ORDER RENDERER
     ========================================================= */

  function renderOrder({
    school,
    profile,
    brand,
    selections,
    history = [],
    overrides = new Set(),
    activePeriodId = "",
    cartBusy = false
  } = {}) {
    const d =
      dom();


    if (
      !school ||
      !profile ||
      !brand
    ) {
      hide(
        d.orderSection
      );

      return;
    }


    /*
      Once a brand is selected the brand chooser
      can remain visible above it, but the actual
      order section must definitely be shown.
    */

    show(
      d.orderSection
    );


    if (d.orderBrandName) {
      d.orderBrandName.textContent =
        brandDisplayName(
          brand
        );
    }


    const mode =
      engine.brands
        .getOrderMode(
          brand
        );


    if (d.orderBrandMeta) {
      d.orderBrandMeta.textContent =
        mode ===
        engine.ORDER_MODES
          .MONTHLY_WEEKDAYS
          ? `Ordering for ${profileName(profile)}`
          : `Choose lunch dates for ${profileName(profile)}`;
    }


    /*
      Global configurable options have their
      own existing HTML container.
    */

    renderGlobalOptions(
      brand,
      selections
    );


    if (
      mode ===
      engine.ORDER_MODES
        .MONTHLY_WEEKDAYS
    ) {
      /*
        IMPORTANT:
        Monthly ordering needs the same
        school/profile/history/override data
        as regular date ordering.

        This is what allows Daily Milk duplicate
        detection to work.
      */

      renderMonthlyOrdering({
        school,
        profile,
        brand,
        selections,
        history,
        overrides,
        activePeriodId
      });

    } else {
      renderDateOrdering({
        school,
        profile,
        brand,
        selections,
        history,
        overrides
      });
    }


    renderSummary({
      brand,
      selections,
      activePeriodId,
      cartBusy
    });
  }
    /* =========================================================
     CART ERROR
     ========================================================= */

  function setCartError(
    message = ""
  ) {
    const d =
      dom();


    let error =
      $("byl-cart-error");


    if (
      !error &&
      d.orderSummary
    ) {
      error =
        create(
          "div",
          "byl-cart-error hidden"
        );

      error.id =
        "byl-cart-error";


      d.orderSummary
        .insertBefore(
          error,
          d.orderSummary
            .firstChild
        );
    }


    if (!error) {
      if (message) {
        setGlobalMessage(
          message,
          "error"
        );
      }

      return;
    }


    error.textContent =
      message;


    if (message) {
      show(
        error
      );

    } else {
      hide(
        error
      );
    }
  }


  /* =========================================================
     STATIC EVENT BINDINGS
     ========================================================= */

  let staticBound =
    false;


  function bindStaticEvents() {
    if (staticBound) {
      return;
    }


    staticBound =
      true;


    const d =
      dom();
    /* ---------------------------------
       Calendar ordering
       --------------------------------- */

    d.calendarButton
      ?.addEventListener(
        "click",
        event => {
          event.preventDefault();

          callbacks
            .onCalendarOpen?.();
        }
      );

    d.calendarClose
      ?.addEventListener(
        "click",
        () => {
          callbacks
            .onCalendarClose?.();
        }
      );

    d.calendarClear
      ?.addEventListener(
        "click",
        () => {
          callbacks
            .onCalendarClear?.();
        }
      );

    d.calendarSubmit
      ?.addEventListener(
        "click",
        async () => {
          if (
            d.calendarSubmit.disabled
          ) {
            return;
          }

          await callbacks
            .onCalendarSubmit?.();
        }
      );

    /*
      School gate
    */

    bindSchoolGate();


    /*
      School switcher
    */

    d.schoolSwitcher
      ?.addEventListener(
        "change",
        () => {
          const schoolId =
            clean(
              d.schoolSwitcher
                .value
            );


          if (!schoolId) {
            return;
          }


          callbacks
            .onSchoolChange?.(
              schoolId
            );

          window.setTimeout(
            () => scrollToElement(
              dom().profileSection
            ),
            260
          );
        }
      );


    /*
      Add another school
    */

    d.addSchool
      ?.addEventListener(
        "click",
        () => {
          openSchoolModal();
        }
      );


    /*
      Add-school modal form
    */

    d.addSchoolForm
      ?.addEventListener(
        "submit",
        async event => {
          event.preventDefault();


          const code =
            clean(
              d.addSchoolCode
                ?.value
            );


          if (!code) {
            setFieldError(
              d.addSchoolError,
              "Enter your school code."
            );

            d.addSchoolCode
              ?.focus();

            return;
          }


          setFieldError(
            d.addSchoolError,
            ""
          );


          try {
            /*
              The same school-code callback can
              handle initial unlock and adding
              another school.
            */

            if (
              typeof callbacks
                .onSchoolCode ===
              "function"
            ) {
              await callbacks
                .onSchoolCode(
                  code
                );
            }


            closeSchoolModal();

          } catch (error) {
            setFieldError(
              d.addSchoolError,

              error?.message ||
              "That school code could not be verified."
            );
          }
        }
      );


    /*
      Close school modal buttons / backdrop
    */

    document
      .querySelectorAll(
        "[data-byl-close-school-modal]"
      )
      .forEach(
        element => {
          element.addEventListener(
            "click",
            () => {
              closeSchoolModal();
            }
          );
        }
      );


    /*
      Escape closes modal.
    */

    document.addEventListener(
      "keydown",
      event => {
        if (
          event.key ===
          "Escape"
        ) {
          const modal =
            dom().schoolModal;


          if (
            modal &&
            !modal.hidden
          ) {
            closeSchoolModal();
          }
        }

        if (
          event.key ===
          "Escape"
        ) {
          document
            .querySelectorAll(
              ".byl-price-menu.is-open"
            )
            .forEach(
              menu =>
                menu.classList
                  .remove(
                    "is-open"
                  )
            );
        }
      }
    );

    document.addEventListener(
      "click",
      event => {
        const orderOption =
          event.target?.closest?.(
            "#byl-order-section .byl-price-menu-option"
          );

        if (orderOption) {
          const row =
            orderOption.closest(
              "[data-byl-service-date]"
            );

          scrollAfterOrderInput(
            row?.dataset
              ?.bylServiceDate || "",
            row
              ? "next"
              : "summary"
          );
        }

        document
          .querySelectorAll(
            ".byl-price-menu.is-open"
          )
          .forEach(menu => {
            if (
              !menu.contains(
                event.target
              )
            ) {
              menu.classList.remove(
                "is-open"
              );
            }
          });
      }
    );

    document.addEventListener(
      "change",
      event => {
        const select =
          event.target?.closest?.(
            "#byl-order-section select"
          );

        if (!select) {
          return;
        }

        const row =
          select.closest(
            "[data-byl-service-date]"
          );

        scrollAfterOrderInput(
          row?.dataset
            ?.bylServiceDate || "",
          row
            ? "next"
            : "summary"
        );
      }
    );


    /*
      Existing Liquid add-profile button.
    */

    d.newProfile
      ?.addEventListener(
        "click",
        () => {
          callbacks
            .onProfileEdit?.(
              null
            );
        }
      );


    /*
      Student / staff / office selector
    */

    d.memberType
      ?.addEventListener(
        "change",
        () => {
          updateProfileType();
        }
      );


    /*
      Save / use profile
    */

    d.profileUse
      ?.addEventListener(
        "click",
        async () => {
          const result =
            readProfileEditor();


          if (!result.valid) {
            setGlobalMessage(
              result.error,
              "error"
            );

            return;
          }


          try {
            d.profileUse.disabled =
              true;


            await callbacks
              .onProfileSave?.(
                result.profile
              );


            closeProfileEditor();

          } catch (error) {
            setGlobalMessage(
              error?.message ||
              "The profile could not be saved.",
              "error"
            );

          } finally {
            d.profileUse.disabled =
              false;
          }
        }
      );


    /*
      Cancel profile editor
    */

    d.profileCancel
      ?.addEventListener(
        "click",
        () => {
          closeProfileEditor();

          callbacks
            .onProfileCancel?.();
        }
      );


    /*
      Back to brands
    */

    d.backToBrands
      ?.addEventListener(
        "click",
        () => {
          hide(
            d.orderSection
          );


          show(
            d.brandSection
          );


          scrollToElement(
            d.brandSection
          );
        }
      );


    /*
      Add to cart.

      Core owns validation and the actual cart
      operation. UI prevents accidental rapid
      double-clicks while the callback is running.
    */

    d.addToCart
      ?.addEventListener(
        "click",
        async () => {
          if (
            d.addToCart.disabled
          ) {
            return;
          }


          setCartError(
            ""
          );


          try {
            d.addToCart.disabled =
              true;

            d.addToCart.textContent =
              "Adding...";


            await callbacks
              .onAddToCart?.();

          } catch (error) {
            setCartError(
              error?.message ||
              "Your order could not be added to the cart."
            );

          } finally {
            /*
              Core normally rerenders immediately
              after the cart action. If it does not,
              make sure the button is not permanently
              stuck in its busy state.
            */

            if (
              d.addToCart
            ) {
              d.addToCart.textContent =
                "Add to Cart";

              d.addToCart.disabled =
                false;
            }
          }
        }
      );
  }


  /* =========================================================
     MAIN APP RENDER
     ========================================================= */

  function render({
    schools = [],
    currentSchool = null,

    profiles = [],
    currentProfile = null,

    brands = [],
    currentBrand = null,

    selections = null,

    history = [],

    overrides =
      new Set(),

    activePeriodId = "",

    cartBusy = false,

    loading = false,

    loadingText = "Loading…"
  } = {}) {
    const d =
      dom();


    setLoading(
      loading,
      loadingText
    );


    /*
      No verified school:
      show ONLY the school-code gate.
    */

    if (!currentSchool) {
      showSchoolGate();

      hide(
        d.profileSection
      );

      hide(
        d.brandSection
      );

      hide(
        d.orderSection
      );

      return;
    }


    hideSchoolGate();


    /*
      School bar
    */

    renderSchools({
      schools,
      currentSchool
    });


    /*
      Profiles
    */

    renderProfiles({
      profiles,

      currentProfileId:
        currentProfile?.id ||
        ""
    });


    /*
      No selected profile yet.
    */

    if (!currentProfile) {
      hide(
        d.brandSection
      );

      hide(
        d.orderSection
      );

      return;
    }


    /*
      Brands
    */

    renderBrands({
      brands,

      currentBrandId:
        currentBrand?.brandId ||
        ""
    });


    /*
      No selected brand yet.
    */

    if (!currentBrand) {
      hide(
        d.orderSection
      );

      return;
    }


    /*
      Order builder
    */

    renderOrder({
      school:
        currentSchool,

      profile:
        currentProfile,

      brand:
        currentBrand,

      selections:
        selections ||
        engine.selections
          .create(
            currentBrand
          ),

      history,

      overrides,

      activePeriodId,

      cartBusy
    });
  }


  /* =========================================================
     PROFILE EDITOR PUBLIC HELPERS
     ========================================================= */

  function editProfile({
    profile = null,
    school = null
  } = {}) {
    const teachers =
      school?.teachers ||
      [];


    openProfileEditor({
      profile,
      teachers
    });
  }


  function cancelProfileEdit() {
    closeProfileEditor();
  }


  /* =========================================================
     SCHOOL MODAL PUBLIC HELPERS
     ========================================================= */

  function schoolModalError(
    message = ""
  ) {
    setFieldError(
      dom().addSchoolError,
      message
    );
  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function init() {
    bindStaticEvents();

    ensureAllergyEditor();


    /*
      Start with clean optional UI pieces.
      Core will immediately render actual state.
    */

    const d =
      dom();


    if (
      d.message &&
      !clean(
        d.message.textContent
      )
    ) {
      hide(
        d.message
      );
    }


    if (
      d.codeError &&
      !clean(
        d.codeError.textContent
      )
    ) {
      hide(
        d.codeError
      );
    }


    if (
      d.addSchoolError &&
      !clean(
        d.addSchoolError.textContent
      )
    ) {
      hide(
        d.addSchoolError
      );
    }


    /*
      Do not force the school gate here.

      Core decides whether a saved signed school
      token can restore the ordering experience.
    */
  }


   /* =========================================================
     CORE-COMPATIBLE RESET FUNCTIONS
     ========================================================= */

  function resetOrder() {
    const d = dom();

    clear(
      d.workspace
    );

    clear(
      d.orderOptions
    );

    if (d.orderTotal) {
      d.orderTotal.textContent =
        "$0.00";
    }

    if (d.addToCart) {
      d.addToCart.disabled =
        true;

      d.addToCart.textContent =
        "Add to Cart";
    }

    hide(
      d.orderOptions
    );

    hide(
      d.existingSummary
    );

    hide(
      d.orderSection
    );

    setCartError(
      ""
    );
  }


  function resetAfterSchoolChange() {
    const d = dom();

    resetOrder();

    clear(
      d.brandList
    );

    hide(
      d.brandSection
    );

    closeProfileEditor();
  }


  function showCartError(
    message
  ) {
    setCartError(
      message
    );
  }


  function clearCartError() {
    setCartError(
      ""
    );
  }


  /* =========================================================
     PUBLIC API

     IMPORTANT:
     This structure matches the existing byl-core.js contract.
     ========================================================= */

  BYL.ui = {
    configure,

    init,


    loading: {
      set:
        setLoading
    },


    messages: {
      set:
        setGlobalMessage,

      cartError:
        showCartError,

      clearCartError:
        clearCartError
    },


    school: {
      showGate:
        showSchoolGate,

      hideGate:
        hideSchoolGate,

      gateError:
        schoolGateError,

      render:
        renderSchools,

      openAddModal:
        openSchoolModal,

      closeAddModal:
        closeSchoolModal
    },


    profiles: {
      render:
        renderProfiles,

      openEditor:
        openProfileEditor,

      closeEditor:
        closeProfileEditor,

      readEditor:
        readProfileEditor,

      renderTeachers:
        populateTeachers
    },


    brands: {
      render:
        renderBrands
    },


    order: {
      render:
        renderOrder,

      date:
        renderDateOrdering,

      monthly:
        renderMonthlyOrdering,

      summary:
        renderSummary,

      reset:
        resetOrder
    },


    calendar: {
      render:
        renderCalendarOrdering
    },


    resetAfterSchoolChange
  };


  /* =========================================================
     INITIALIZE
     ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once: true
      }
    );

  } else {
    init();
  }

})();
